<template>
  <div class="wrapper">
      <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card>
            <div slot="header">
              <strong>Create Match </strong> <small></small>
            </div>
            <b-form>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="home_name" class="text-info">HOME TEAM NAME</label>
                    <b-form-input type="text" class="form-control" id="home_name" placeholder="Ex: Real Madrid" v-model="home_name" required></b-form-input>
                    <div class="invalid-feedback d-block" v-show="errors.home_name">{{ errors.home_name }}</div>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="away_name" class="text-info">AWAY TEAM NAME</label>
                    <b-form-input type="text" class="form-control" id="away_name" placeholder="Ex: Real Madrid" v-model="away_name" required></b-form-input>
                    <div class="invalid-feedback d-block" v-show="errors.away_name">{{ errors.away_name }}</div>
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <label class="text-info my-2 text-center d-block">ODDS COMPARISON</label>
                  <b-form-group>
                    <label for="book1_name" class="text-info">BOOKMAKER NAME 1</label>
                    <b-form-input type="text" class="form-control" id="book1_name" placeholder="Ex: bet365" v-model="odds['bet365']._attributes.name" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book1_odd_1" class="text-info">ODD 1</label>
                    <b-form-input type="text" class="form-control" id="book1_odd_1" placeholder="Ex: 2.20" v-model="odds['bet365'].odd[0]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book1_odd_x" class="text-info">ODD X</label>
                    <b-form-input type="text" class="form-control" id="book1_odd_x" placeholder="Ex: 2.20" v-model="odds['bet365'].odd[2]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book1_odd_2" class="text-info">ODD 2</label>
                    <b-form-input type="text" class="form-control" id="book1_odd_2" placeholder="Ex: 2.20" v-model="odds['bet365'].odd[1]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <hr>
                  <b-form-group>
                    <label for="book2_name" class="text-info">BOOKMAKER NAME 2</label>
                    <b-form-input type="text" class="form-control" id="book2_name" placeholder="Ex: bet365" v-model="odds['888Sport']._attributes.name" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book2_odd_1" class="text-info">ODD 1</label>
                    <b-form-input type="text" class="form-control" id="book2_odd_1" placeholder="Ex: 2.20" v-model="odds['888Sport'].odd[0]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book2_odd_x" class="text-info">ODD X</label>
                    <b-form-input type="text" class="form-control" id="book2_odd_x" placeholder="Ex: 2.20" v-model="odds['888Sport'].odd[2]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book2_odd_2" class="text-info">ODD 2</label>
                    <b-form-input type="text" class="form-control" id="book2_odd_2" placeholder="Ex: 2.20" v-model="odds['888Sport'].odd[1]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <hr>
                  <b-form-group>
                    <label for="book3_name" class="text-info">BOOKMAKER NAME 3</label>
                    <b-form-input type="text" class="form-control" id="book3_name" placeholder="Ex: bet365" v-model="odds['bwin']._attributes.name" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book3_odd_1" class="text-info">ODD 1</label>
                    <b-form-input type="text" class="form-control" id="book3_odd_1" placeholder="Ex: 2.20" v-model="odds['bwin'].odd[0]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book3_odd_x" class="text-info">ODD X</label>
                    <b-form-input type="text" class="form-control" id="book3_odd_x" placeholder="Ex: 2.20" v-model="odds['bwin'].odd[2]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="book3_odd_2" class="text-info">ODD 2</label>
                    <b-form-input type="text" class="form-control" id="book3_odd_2" placeholder="Ex: 2.20" v-model="odds['bwin'].odd[1]._attributes.value" required></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <hr>
                  <b-button type="submit" size="md" variant="danger" @click.prevent="saveBanner"><i class="fa fa-dot-circle-o"></i> Save</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
     </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Create',
  data () {
    return {
      home_name: '',
      away_name: '',
      odds: {
        bet365: {
          _attributes: {
            id: '',
            name: ''
          },
          odd: [
            {
              _attributes: {
                name: '1',
                value: ''
              }
            },
            {
              _attributes: {
                name: '2',
                value: ''
              }
            },
            {
              _attributes: {
                name: 'X',
                value: ''
              }
            }
          ]
        },
        '888Sport': {
          _attributes: {
            id: '',
            name: ''
          },
          odd: [
            {
              _attributes: {
                name: '1',
                value: ''
              }
            },
            {
              _attributes: {
                name: '2',
                value: ''
              }
            },
            {
              _attributes: {
                name: 'X',
                value: ''
              }
            }
          ]
        },
        bwin: {
          _attributes: {
            id: '',
            name: ''
          },
          odd: [
            {
              _attributes: {
                name: '1',
                value: ''
              }
            },
            {
              _attributes: {
                name: '2',
                value: ''
              }
            },
            {
              _attributes: {
                name: 'X',
                value: ''
              }
            }
          ]
        }
      },
      errors: {}
    }
  },
  methods: {
    saveBanner () {
      this.errors = {}

      const formData = new FormData()

      formData.append('home_name', this.home_name)
      formData.append('away_name', this.away_name)
      formData.append('odds', JSON.stringify(this.odds))

      if (Object.keys(this.errors).length === 0) {
        this.$http.post(`${this.$api_url}/matches/create`, formData, {
          headers: { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin': '*' }
        }).then((data) => {
          this.$router.push('/matches/manage')
        })
      } else {
        this.errors.general = 'Check the required fields!'
      }
    }
  },
  computed: {
    ...mapGetters(['countries', 'XMPhtml', 'apiKey'])
  },
  created () {
    //
  },
  beforeDestroy () {
    //
  }
}
</script>

<style scoped>

</style>
